import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";

import { MatrizRiesgoService } from "../matriz-riesgo.service";
import { FechaBitacoraPipe } from "../fecha-bitacora.pipe";
import { MatrizHistorial } from "src/app/shared/model/iso42001/matriz-riesgo.model";

/**
 * Bitácora de cambios de un activo de la matriz.
 *
 * La base guarda el NOMBRE FÍSICO de la columna en campo_modificado; el mapa
 * ETIQUETAS lo traduce a algo legible. Si se agrega un campo al diff del Buss,
 * hay que agregarlo también aquí.
 */
@Component({
  selector: "app-historial-matriz-riesgos-ia",
  standalone: true,
  templateUrl: "./historial-matriz-riesgos-ia.component.html",
  styleUrls: ["./historial-matriz-riesgos-ia.component.css"],
  imports: [CommonModule, MatButtonModule, FechaBitacoraPipe],
})
export class HistorialMatrizRiesgosIAComponent implements OnInit {
  historial: MatrizHistorial[] = [];
  loading = false;

  private static readonly ETIQUETAS: { [k: string]: string } = {
    nombre_activo: "Nombre del activo",
    tipo_activo: "Tipo de activo",
    val_confidencialidad: "Confidencialidad",
    val_integridad: "Integridad",
    val_disponibilidad: "Disponibilidad",
    justificacion_valoracion: "Justificación de la valoración",
    activos_dependientes: "Activos dependientes",
    id_inventario_ia: "Folio del inventario IA",
    fecha_identificacion: "Fecha de identificación",
    amenazas: "Amenazas",
    seguimiento: "Seguimiento",
    estatus: "Estatus",
    alta: "Alta del activo",
    // Ya no se genera; queda para las bases sin la limpieza de la bitácora.
    migracion: "Origen del registro",
  };

  constructor(
    private service: MatrizRiesgoService,
    private route: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get("id");
    if (!id) {
      this.regresar();
      return;
    }
    this.loading = true;
    this.service.historial(Number(id)).subscribe({
      next: (res) => {
        this.historial = res.historial || [];
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error("Error al consultar la bitácora", err);
        this.loading = false;
        this.cdr.detectChanges();
      },
    });
  }

  etiqueta(campo?: string): string {
    if (!campo) {
      return "—";
    }
    return HistorialMatrizRiesgosIAComponent.ETIQUETAS[campo] || campo;
  }

  regresar(): void {
    this.router.navigate(["/admin/matriz-riesgos-ia/gestion"]);
  }
}
